import React from "react";
import { Button } from "../ui/button";
import { Loader, Pencil, Save } from "lucide-react";

interface Props {
  isEditing: boolean;
  handleEditing: () => void;
  isNoChange: () => boolean;
  handleSave: (e: React.FormEvent) => Promise<void>;
  handleCancel: () => void;
  isSubmitting: boolean;
}
function EditButton({
  isEditing,
  handleEditing,
  isNoChange,
  handleSave,
  handleCancel,
  isSubmitting,
}: Props) {
  return (
    <div>
      {isEditing ? (
        <Button
          variant="outline"
          onClick={handleEditing}
          className="transition-all duration-200 animate-in fade-in slide-in-from-left-2"
        >
          <Pencil />
        </Button>
      ) : (
        <div className="flex gap-2 transition-all duration-200 animate-in fade-in slide-in-from-right-2">
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            type="button"
            variant={isNoChange() || isSubmitting ? "secondary" : "default"}
            disabled={isNoChange() || isSubmitting}

          >
            {isSubmitting ? <Loader className="animate-spin" /> : <Save />}
          </Button>
        </div>
      )}
    </div>
  );
}

export default EditButton;
